import PUBLIC_SERVICES from './public';
import PRIVATE_SERVICES from './private';

const APP_SERVICES = {
	PUBLIC_SERVICES,
	PRIVATE_SERVICES
};

export default APP_SERVICES;
